import type {ReactElement} from 'react';
import {StockPanelMessage} from '@Panels/stock-panel/components/stock-panel-message/stock-panel-message';

export interface StockPanelNoResultsProps {
  className?: string;
  searchTerm: string;
  aiCta?: ReactElement;
}

export default function StockPanelNoResults({...props}: StockPanelNoResultsProps): ReactElement {
  const getMessageText = (): string => {
    if (props.searchTerm === '') {
      return window.i18next.t('pmwjs_we_couldnt_find_any_matching_results');
    }
    return window.i18next.t('pmwjs_we_couldnt_find_anything_for_search_term', {searchTerm: props.searchTerm});
  };

  return (
    <StockPanelMessage icon={props.searchTerm === '' ? 'icon-ban' : 'icon-search'} text={getMessageText()} className={props.className}>
      {props.aiCta ?? null}
    </StockPanelMessage>
  );
}
